export const SCROLL_OFFSET = 500;

export const SEARCH_DEBOUNCE_MS = 800;

export const RANKING_LIMIT = 100;

export const MOBILE_BREAKPOINT = 768;

export const DESKTOP_BREAKPOINT = 1024;

export const MAX_ENS_LENGTH_MOBILE = 18;

export const MAX_ENS_LENGTH_DESKTOP = 25;

export const QUERY_STALE_TIME = 30000;

export const QUERY_RETRY = 1;
